import React from 'react'
import Head from 'next/head'

export type SRPProps = {
    title?: string
    description?: string
}

export const SRP = ({ title }: SRPProps): JSX.Element => {
    return (
        <Head>
            <title>{title!}</title>
            <meta name="robots" content="noindex,nofollow" />
        </Head>
    )
}
